export function validateGroupData(group) {
  const p = (val) =>
    val === null || val === '' || val === undefined ? null : parseFloat(val);
  const complexSections = ['basicFeatures', 'bonus'];
  for (const section of complexSections) {
    if (!group[section]) continue;
    for (const item of group[section]) {
      const checkRange = (val, label) => {
        const num = p(val);
        if (num !== null && (num < 0 || num > 100)) {
          return `In ${section} - "${item.name}": ${label} must be between 0 and 100.`;
        }
        return null;
      };
      const err =
        checkRange(item.aesthetics, 'Aesthetics') ||
        checkRange(item.functionality, 'Functionality');
      if (err) return err;
    }
  }
  const simpleSections = ['deployment'];
  for (const section of simpleSections) {
    if (!group[section]) continue;
    for (const item of group[section]) {
      const score = p(item.score);
      const worth = p(item.worth);
      if (score !== null && worth !== null && score > worth) {
        return `In ${section} - "${item.name}": Score (${score}) > Worth (${worth}).`;
      }
      if (score !== null && score < 0) {
        return `In ${section} - "${item.name}": Score cannot be negative.`;
      }
    }
  }
  const adj = group.generalAdjustments;
  if (adj != null && typeof adj === 'object') {
    const pairs = adj instanceof Map ? Array.from(adj.entries()) : Object.entries(adj);
    for (const [, rateVal] of pairs) {
      const rate = p(rateVal);
      if (rate !== null && (rate < 0 || rate > 1)) {
        return 'Student adjustment rates (general) must be between 0 and 1.';
      }
    }
  }
  return null;
}
